import "./cascader.css";
import { Controller as BaseController } from "@hotwired/stimulus";

export class Controller extends BaseController {
  static targets = ["level", "nodeName", "nodeTaxons"];
  static values = { currentDepth: Number };

  connect() {
    this.focusNextAvailableLevel();
  }

  focusNextAvailableLevel() {
    if (!this.hasCurrentDepthValue) return;

    const nextLevel = this.findNextLevel(this.currentDepthValue + 1);
    if (!nextLevel) return;

    const focusable =
      this.findInTargets(this.nodeNameTargets, nextLevel) ||
      this.findInTargets(this.nodeTaxonsTargets, nextLevel) ||
      nextLevel.querySelector(".Taxonomy\\/Cascader-node-taxons");

    if (focusable) {
      queueMicrotask(() => focusable.focus({ preventScroll: true }));
    }
  }

  findNextLevel(startDepth) {
    return this.levelTargets
      .sort((a, b) => a.dataset.depth - b.dataset.depth)
      .find((level) => {
        const depth = Number(level.dataset.depth);
        if (depth < startDepth) return false;

        return (
          this.nodeNameTargets.some((n) => level.contains(n)) ||
          this.nodeTaxonsTargets.some((n) => level.contains(n)) ||
          level.querySelector(".Taxonomy\\/Cascader-node-taxons")
        );
      });
  }

  findInTargets(targets, container) {
    return targets.find((t) => container.contains(t));
  }
}
